import { PropTypes } from 'prop-types';
import { useState } from 'react';
import Accordion from '@/components/common/Accordion';
import AccordionList from '@/components/common/AccordionList';

import styles from '@/components/layout/espots/AccordionESpot.module.scss';
import { ACCORDION_ESPOT_IMG_SIZE } from '@/constants/espot';

export const AccordionEspot = ({ data, lazy = false }) => {
  const { contentTitle, img, alt, orientation, accordion } = data;

  const [opened, setOpened] = useState(Array(accordion.length).fill(false));

  const containerClassName = [
    styles.container,
    orientation === 'RIGHT' && styles.reverse
  ].filter(Boolean).join(' ');

  const changeOpening = (index) => {
    const newArray = opened.slice();
    newArray[index] = !newArray[index];
    setOpened(newArray);
  };

  return (
    <div className={containerClassName} data-test-id="accordion-espot">
      <div className={styles['img-container']}>
        <img
          src={img}
          alt={alt}
          loading={lazy ? 'lazy' : 'eager'}
          width={ACCORDION_ESPOT_IMG_SIZE.WIDTH}
          height={ACCORDION_ESPOT_IMG_SIZE.HEIGHT}
        />
      </div>
      <div className={styles.accordion}>
        <div className={styles.title} data-test-id="title">
          {contentTitle}
        </div>
        <AccordionList withSeparator>
          {accordion.map((accordionBloc, i) => (
            <Accordion
              key={i}
              id={`accordion-${i}`}
              label={accordionBloc.title}
              labelClassName={styles.label}
              open={opened[i]}
              showArrow
              increasedPadding
              onClick={() => changeOpening(i)}
            >
              {accordionBloc.description}
            </Accordion>
          ))}
        </AccordionList>
      </div>
    </div>
  );
};

AccordionEspot.propTypes = {
  data: PropTypes.shape({
    contentTitle: PropTypes.string.isRequired,
    img: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
    orientation: PropTypes.string.isRequired,
    accordion: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
  lazy: PropTypes.bool
};

export default AccordionEspot;
